export default Object.freeze({
    RPOST: {
        RPOST_DELIVERY_METHOD: 'Registered Email™'
    }
  });
  